/**
* Initializer script
*
* To require dependencies and set globals which are environment specific.
* I.E. Performance tools useful in development, error reporters, google analytics
* and other tools useful in production environment only.
*/

import config from 'appConfig';

if (config.development() == true) {
    // Performance analytics
    const Perf = require('react-addons-perf');
    window.Perf = Perf;
} else if (config.production() == true) {
    // Production specific initialize
}



/** WEBPACK FOOTER **
 ** ./src/config/initializer.js
 **/